<mat-card style="min-height: 480px">
  <mat-card-content class="scrollable-content">
    <h4 class="mb-20 fw-bold">{{'SCHOOL_PROGRAM_ACTIVITY'|translate}}</h4>

      <div class="col-md-6 mb-20" style="padding: 0px;">
          <app-select-school-level-relation-v2 (schoolLevelRelationChanged)="onChangeSchoolLevelRelation($event)"
                                               [academic_year]="currentAcademic?.academic_year ?? null"
                                               [all]="false"
                                               [isDisabled]="!currentAcademic">
          </app-select-school-level-relation-v2>
      </div>

      <p class="fw-bold fs-15 d-flex justify-content-center align-items-center mb-5" style="margin-top: 120px" *ngIf="!hasData && !loading">{{'NO_ACTIVITY_AT_MOMENT'|translate}}</p>
      <div *ngIf="!hasData && loading" class="d-flex justify-content-center align-items-center mb-5" style="margin-top: 50px">
          <mat-spinner></mat-spinner>
      </div>
    <div *ngFor="let activity of activity">
        <p class="fw-bold fs-15 flex" *ngIf="hasData">{{ activity.description }}{{ activity.start_date !== '' ? ', ' + activity.start_date : ''}} </p>
        <div  class="d-flex" *ngFor="let schedule of activity.schedule">
            <p class="fw-bold ps-16 pe-20 fs-12">{{ schedule.start_time }}</p>
            <div class="activity-border">
                <div class="deep">
                    <div class="activity-ring">
                        <div class="ring {{ schedule.ringColor }}"></div>
                    </div>
                </div>
                <div class="ps-20 pe-16 activity-message">
                    <p class="fs-14">
                        {{ schedule.extracurricular_name}}
                    </p>
                    <p class="fs-12">
                        {{ schedule.venue && schedule.venue != '' ? schedule.venue : 'No Fixed Venue Yet'}}
                    </p>
                </div>
            </div>
        </div>

    </div>
  </mat-card-content>
</mat-card>
